module.exports = __webpack_public_path__ + "6404d03e34cce49ddf56759f0296d6e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fedex_2023_chart.png
// module id = 1676
// module chunks = 0